import type { CartPage as CartPageProps } from '@/@types/content';
import withNav from '../hocs/withNav';
import ContentArea from '../cms/ContentArea';
import MyCart from '../ui/CheckoutAndOrderManagement/MyCart';

const CartPageComponent: React.FC<CartPageProps> = props => {
  return (
    <>
      <ContentArea
        components={props.aboveCartContentArea}
        propertyName="AboveCartPageContentArea"
      />
      <MyCart context="page" />
      <ContentArea
        components={props.belowCartContentArea}
        propertyName="BelowCartPageContentArea"
      />
    </>
  );
};

const CartPage = withNav(CartPageComponent);
export default CartPage;
